import auth from "../scripts/auth";
const routes = [
    {
        path: "/",
        name: "home",
        redirect(to) {
            let data = auth.getTokenData();
            if (data && data.home) {
                return data.home;
            }
            return "/home/base";
        },
        component: () => import("../views/home.vue"),
        children: [
            {
                path: "/home/base",
                component: () => import("../views/Desktops/base.vue"),
            },
            {
                path: "/home/zzlby",
                component: () => import("../views/Desktops/zzlby/index.vue"),
            },
        ],
    },
    {
        path: "/wsj",
        name: "wsj",
        component: () => import("../views/wsj/layout.vue"),
        children: [
            {
                path: "home",
                component: () => import("../views/wsj/home"),
            },
            {
                path: "rlt",
                component: () => import("../views/wsj/rlt.vue"),
            },
            {
                path: "sjfx",
                component: () => import("../views/wsj/sjfx.vue"),
            },
        ],
    },
    {
        path: "/wsjsys",
        name: "wsjsys",
        component: () => import("../views/wsj/syslayout.vue"),
        children: [
            {
                path: "entity",
                component: () => import("../views/sys/entity.vue"),
                meta: { privCode: "0020001" },
            },
            {
                path: "user",
                component: () => import("../views/sys/user.vue"),
                meta: { privCode: "0020002" },
            },
            {
                path: "role",
                component: () => import("../views/sys/role.vue"),
                meta: { privCode: "0020003" },
            },
            {
                path: "biz-model",
                component: () => import("../views/sys/biz-model.vue"),
                meta: { privCode: "0020005" },
            },
            {
                path: "device",
                component: () => import("../views/sys/device.vue"),
                meta: { privCode: "0020006" },
            },
            {
                path: "log",
                component: () => import("../views/sys/log.vue"),
                meta: { privCode: "0020007" },
            },
        ],
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login.vue"),
        meta: {
            anonymous: true,
        },
    },
    {
        path: "/setting",
        name: "setting",
        component: () => import("../views/setting.vue"),
        meta: {
            anonymous: true,
        },
    },
    {
        path: "/nopriv",
        name: "nopriv",
        component: () => import("../views/nopriv.vue"),
        meta: {
            anonymous: true,
        },
    },
    {
        path: "/flow",
        name: "flow",
        component: () => import("../views/FlowData/index.vue"),
        children: [
            {
                path: "/flow/shop/day", ///flow/shop/summary
                name: "shop",
                component: () => import("../views/FlowData/Shop/day.vue"),
            },
            {
                path: "/flow/shop/summary",
                name: "summary",
                component: () => import("../views/FlowData/Shop/summary.vue"),
            },
            {
                path: "/flow/shop/trend",
                name: "trend",
                component: () => import("../views/FlowData/Shop/trend.vue"),
            },
            {
                path: "/flow/shop/area-analysis",
                name: "areaAnalysis",
                component: () => import("../views/FlowData/Shop/area-analysis.vue"),
            },
            {
                path: "/flow/shop/type",
                name: "type",
                component: () => import("../views/FlowData/Shop/type.vue"),
            },
            {
                path: "/flow/shop/holiday",
                name: "holiday",
                component: () => import("../views/FlowData/Shop/holiday.vue"),
            },
            {
                path: "/flow/shop/time-flow",
                name: "timeFlow",
                component: () => import("../views/FlowData/Shop/time-flow.vue"),
            },
            {
                path: "/flow/shop/flow-distribute",
                name: "flowDistribute",
                component: () => import("../views/FlowData/Shop/flow-distribute.vue"),
            },
            {
                path: "/flow/shop/rank-analysis",
                name: "rankDistribute",
                component: () => import("../views/FlowData/Shop/rank-analysis.vue"),
            },
            {
                path: "/flow/shop/compare-analysis",
                name: "compareAnalysis",
                component: () => import("../views/FlowData/Shop/compare-analysis.vue"),
            },
            {
                path: "/flow/shop/flow-compare",
                name: "flowCompare",
                component: () => import("../views/FlowData/Shop/flow-compare.vue"),
            },
            {
                path: "/flow/statistic",
                name: "Statistic",
                component: () => import("../views/FlowData/statistic.vue"),
            },
            {
                path: "/flow/shop/door",
                name: "shopdoor",
                component: () => import("../views/FlowData/Shop/door-details.vue"),
            },
            {
                path: "/flow/shop/doortotal",
                name: "shopdoortotal",
                component: () => import("../views/FlowData/Shop/door-total.vue"),
            },
            {
                path: "/flow/shop/entity",
                name: "entitydetail",
                component: () => import("../views/FlowData/Shop/entity-detail.vue"),
            },
        ],
    },
    {
        path: "/opearte",
        name: "opearte",
        component: () => import("../views/OpearteData/index.vue"),
        children: [
            {
                path: "/opearte/shop",
                component: () => import("../views/OpearteData/shop.vue"),
            },
        ],
    },
    {
        path: "/platform",
        component: () => import("../views/platform/index.vue"),
        children: [
            {
                path: "/platform/tenant",
                component: () => import("../views/platform/tenant.vue"),
                meta: { privCode: "0010001" },
            },
            {
                path: "/platform/entity",
                component: () => import("../views/platform/entity.vue"),
                meta: { privCode: "0010001" },
            },
            {
                path: "/platform/app",
                component: () => import("../views/platform/app.vue"),
                meta: { privCode: "0010003" },
            },
            {
                path: "/platform/holiday",
                component: () => import("../views/platform/holiday.vue"),
                meta: { privCode: "0010002" },
            },
            {
                path: "/platform/db",
                component: () => import("../views/platform/db.vue"),
                meta: { privCode: "0010004" },
            },
        ],
    },
    {
        path: "/ops",
        component: () => import("../views/ops/index.vue"),
        children: [
            {
                path: "/ops/flow",
                component: () => import("../views/ops/flow.vue"),
                meta: { privCode: "0030001" },
            },
            {
                path: "/ops/import-flow",
                component: () => import("../views/ops/import-flow.vue"),
                meta: { privCode: "0030002" },
            },
            {
                path: "/ops/import-operate",
                component: () => import("../views/ops/import-operate.vue"),
                meta: { privCode: "0030003" },
            },
        ],
    },
    {
        path: "/sys",
        component: () => import("../views/sys/index.vue"),
        children: [
            {
                path: "/sys/entity",
                component: () => import("../views/sys/entity.vue"),
                meta: { privCode: "0020001" },
            },
            {
                path: "/sys/user",
                component: () => import("../views/sys/user.vue"),
                meta: { privCode: "0020002" },
            },
            {
                path: "/sys/role",
                component: () => import("../views/sys/role.vue"),
                meta: { privCode: "0020003" },
            },
            {
                path: "/sys/biz-model",
                component: () => import("../views/sys/biz-model.vue"),
                meta: { privCode: "0020005" },
            },
            {
                path: "/sys/device",
                component: () => import("../views/sys/device.vue"),
                meta: { privCode: "0020006" },
            },
            {
                path: "/sys/log",
                component: () => import("../views/sys/log.vue"),
                meta: { privCode: "0020007" },
            },
        ],
    },
];
export default routes;
